import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { useTheme } from '../hooks/ThemeProvider';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            className="themeBtn"
            onClick={toggleTheme}
        >
            <FontAwesomeIcon icon={theme === "dark" ? faSun : faMoon} />
        </button>
    );
}

export default ThemeToggle